import React, { Component } from "react";
import PropTypes from "prop-types";
import { AccountService } from "@services";
import { Loader } from "../../components";

import "./Activation.scss";

// Unused page, this page is currently served from the backend
class Activation extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: true,
			message: "",
		};
	}

	componentDidMount() {
		const { lang } = global;
		const {
			location: { query },
		} = this.props;
		if (!query?.id) {
			this.setState({ loading: false, message: lang.t("Invalid activation link") });
		} else {
			AccountService.activate(query.id)
				.then(({ data }) => {
					this.setState({
						loading: false,
						message: data.Message,
					});
				})
				.catch(() => {
					this.setState({ loading: false, message: lang.t("Invalid activation link") });
				});
		}
	}

	render() {
		const { loading, message } = this.state;
		const { lang } = global;

		return (
			<div
				id="activation-page"
				className="container-fluid"
			>
				<div className="row">
					<div className="col-xs-12">
						<img
							src="/images/rk-logo-new.png"
							alt="RollKall"
							className="img-responsive"
						/>
					</div>
				</div>
				<div className="row activation-message text-center">
					<div className="col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4">
						<p>{message}</p>
						<Loader
							active={loading}
							size="small"
							spinnerOnly
						/>
					</div>
				</div>
				<div className="row">
					<div className="col-sm-12 text-center">
						<a href="/login">{lang.t("Back to Login")}</a>
					</div>
				</div>
			</div>
		);
	}
}

Activation.propTypes = { location: PropTypes.object.isRequired };

export default Activation;
